import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';
import banner8 from '../assets/banner8.jpg';
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import { MdChildCare, MdElderly, MdFace, MdFemale } from "react-icons/md";

export default function HomeBanner1(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner2, banner6, banner7, banner8, banner1, banner5, banner3, banner4, ];

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if (ready) {
		return (
			<div className="MainBodySection">
				<div
					style={{
						width: "100%",
						height: "auto",
						position: "relative",
						overflow: "auto"
					}}
				>
					{banners.map((banner, i) => (
						<div
							key={i}
							style={{
								backgroundImage: `url(${banner})`,
								backgroundAttachment: "fixed",
								backgroundSize: "cover",
								backgroundPosition: "center",
								width: "100%",
								height: "100%",
								position: "absolute",
								top: 0,
								left: 0,
								transition: "opacity 1.5s ease-in-out",
								opacity: i === bgIndex ? 1 : 0,
							}}
						/>
					))}

					{/* gradient overlay */}
					<div
						style={{
							width: "100%",
							height: "100%",
							background: "rgba(0, 0, 0, 0.7)",
							position: "relative",
							zIndex: 1
						}}
					>
						<div className="container">
							<div className="row">
								<div className="col-md-12">
									<h1 className="text-light font-light p-5 text-center">
										We serve a range of Most Vulnerable Groups:
									</h1>
								</div>

								<div className="col-md-12 text-light p-5">
									<div className="row g-4">
										<div className="col-md-3 text-center">
											<div
												style={{
													background:"white",
													width:"60px",
													height:"60px",
													borderRadius:"50%",
													display:"grid",
													placeItems:"center",
													margin:"auto"
												
												}}
											>
												<MdChildCare size={48} color="#FF6B6B" />
											</div>
											<h6 className="mt-2 font-bold">Children</h6>
											<p>Providing education, nutrition, and psychosocial support to help children thrive.</p>
										</div>

										<div className="col-md-3 text-center">
											<div
												style={{
													background:"white",
													width:"60px",
													height:"60px",
													borderRadius:"50%",
													display:"grid",
													placeItems:"center",
													margin:"auto"
												
												}}
											>
												<MdFace size={48} color="#4ECDC4" />
											</div>
											<h6 className="mt-2 font-bold">Adolescents & Youth</h6>
											<p>Empowering young people with skills, mentorship, and opportunities for growth.</p>
										</div>

										<div className="col-md-3 text-center">
											<div
												style={{
													background:"white",
													width:"60px",
													height:"60px",
													borderRadius:"50%",
													display:"grid",
													placeItems:"center",
													margin:"auto"
												
												}}
											>
												<MdFemale size={48} color="#FF9F1C" />
											</div>
											<h6 className="mt-2 font-bold">Women</h6>
											<p>Supporting economic empowerment, leadership, and access to resources.</p>
										</div>

										<div className="col-md-3 text-center">
											<div
												style={{
													background:"white",
													width:"60px",
													height:"60px",
													borderRadius:"50%",
													display:"grid",
													placeItems:"center",
													margin:"auto"
												
												}}
											>
												<MdElderly size={48} color="#6A4C93" />
											</div>
											<h6 className="mt-2 font-bold">Elderly</h6>
											<p>Providing care, inclusion, and support for older community members.</p>
										</div>
										</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
